import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {ClientSidePermissionContainerModel} from '../../../../../models/aggregates/permissions';
import {Core2Config} from '../shared/core2Config';
import { ApiResponseModel, ApiVisa } from '../shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TenantClientSidePermissionService extends BaseApiTemplateService<ClientSidePermissionContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'client-side-permissions/applet-admin-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX
      + 'client-side-permissions/applet-admin-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'client-side-permissions/applet-admin-ep';
    this.httpClient = http;
  }

  getBySubjectAndAppletGuid(loginSubjectGuid: string, appletGuid: string, apiVisa: ApiVisa): Observable<ApiResponseModel<ClientSidePermissionContainerModel>> {
    let url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX
    + 'client-side-permissions' + '/applet-user-ep/' + loginSubjectGuid + '?applet-guid=' + appletGuid;
    if (apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + url;
    }else{
      url = Core2Config.DOMAIN_URL + url;
    }
    return this.httpClient.get<ApiResponseModel<ClientSidePermissionContainerModel>>(url, this.getHttpHeader(apiVisa));
  }
}
